<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Base Recupero por Estudio y Tramo</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <v-row dense>
                    <v-col cols ="3">
                        <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Casos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                    <v-col >
                        <v-select v-model="filtro.estudios" :items="listEstudios" autocomplete="disabled" multiple
                            item-text="descripcion" item-value="id" label="en Estudio" placeholder="Seleccione uno" :menu-props="{minWidth:'400'}"></v-select>
                    </v-col>

                </v-row>

                <v-row dense>
                    <v-col cols="2" >
                       <v-text-field v-model="filtro.fechaDesde" label="Desde" type="date" prepend-icon="event"></v-text-field>
                    </v-col>
                    <v-col cols="2" >
                       <v-text-field v-model="filtro.fechaHasta" label="Hasta" type="date" prepend-icon="event"></v-text-field>
                    </v-col>
                </v-row>
                
                <span class="title" >Opciones</span>
                <v-divider></v-divider>
                <v-row dense>
                    <v-col cols="2" lg="1">
                        <v-text-field v-model="filtro.separador" label="Separador en archivo"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                                
                <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="procesar">
                    Descargar&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            filtro: {empresaId: 1, estudios:[], fechaDesde: null, fechaHasta: null, separador: ';'},
            listEmpresas: [],
            listEstudios: [],
            
        }
    },
    async created() {
      this.loadEmpresas();
      this.loadEstudios();

      this.filtro.fechaDesde = this.$moment(new Date()).format('2005-01-01');
      this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');    
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
        return this.getActionFromLink(this.$route.path) 
        },
        componentsLoading: function(){
        return this.loadingCreditosEnMora || this.loadingTelefonos || this.loadingGestionesTelefonicas || this.loadingOtrasGestiones;
        }
    },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadEstudios(){
        this.loading = true;
        try{
            var result = await http.get('estudiosexternos');

            this.listEstudios = result.list;
            this.listEstudios.unshift({id:0,descripcion:'(Todos)'});
            
           this.filtro.estudios = [];
            this.filtro.estudios.push(0);
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async procesar(){
         // validaciones
        if(this.filtro.empresaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Empresa.');
            return;
        }
        var self = this;
        var filtros = this.filtro;

        filtros.estudios = this.filtro.estudios.toString();        

        try {
            self.loading = true;

            await http.post('filegeneration/baserecupero', JSON.stringify( {parametros: filtros} ) )
                .then(resp => {

                    if(resp.error ){
                        self.alertError(resp.error);
                    }
                    else{
                        self.alertSuccess('Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...');
                        
                        self.loading = true;
                        self.downloadFile(resp, 'BaseRecupero.csv');
                        self.loading = false;
                    }

                })
                .catch((e) => {
                    self.alertError(e)
                });
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
    async downloadFile(file, renameTo){
        //convierto el string del path a base64 para poder mandarlo
        let base64String = '';
        base64String = btoa(file.fullPath);
        
        http.get('filemanagement/getfilebypath/'+base64String)
        .then(resp => {
            let dataType = '';
            switch(resp.extension)
            {
                case '.doc':
                case '.docx':
                case '.DOC':
                case '.DOCX':
                    dataType = 'data:application/vnd.ms-word';
                    break;
                case '.pdf':
                case '.PDF':
                    dataType = 'data:application/pdf'
            }
            
            //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
            var arrayBuffer = this.base64ToArrayBuffer(resp.file);
            this.saveByteArray(renameTo, arrayBuffer,dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], {type: dataType});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();      
    },

},
  
}
</script>